import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessSegmentFormComponent } from './business-segment-form/business-segment-form.component';
import { BusinessSegmentListComponent } from './business-segment-list/business-segment-list.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BussinessSegmentRoutingModule } from './bussiness-segment-routing.module';



@NgModule({
  declarations: [
    BusinessSegmentFormComponent,
    BusinessSegmentListComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    BussinessSegmentRoutingModule,
    FormsModule
  ]
})
export class BusinessSegmentModule { }
